exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editarTime .h2_title[data-v-b33ad5d4] {\n  font-weight: normal;\n}\n#cardDivTV[data-v-b33ad5d4] {\n  width: 100%;\n}\n.btn-grabar[data-v-b33ad5d4] {\n  background-color: #ff6c00 !important;\n}\n", ""]);

// exports
